import { useMemo } from 'react';
import { usePayment } from '$api-clients/hooks';
import {
  buildReportingSummaryPerformanceQuery,
  shouldUseYearlyReportingPeriod,
} from '../../helpers';
import { useAllTimeStartDate } from '../../ReportsConfiguration/useReportsConfiguration';
import { usePerformanceReportContext } from '../context/PerformanceReportContext';

export const usePerformanceSnapshot = ({
  viewReportAs,
}: {
  viewReportAs: string;
}) => {
  const { filters } = usePerformanceReportContext();
  const allTimeStartDate = useAllTimeStartDate();
  const query = buildReportingSummaryPerformanceQuery(
    filters,
    viewReportAs,
    allTimeStartDate,
  );
  const useYearlyPeriod = shouldUseYearlyReportingPeriod(
    filters?.reportingPeriod,
  );

  const { data, isLoading } = usePayment('/reporting/summary', {
    params: {
      query: {
        ...query,
        limit: 1,
        offset: 0,
        ...(useYearlyPeriod ? { period: 'YEARLY' } : undefined),
      },
    },
  });

  const {
    data: transactionSidesData,
    isLoading: isLoadingTransactionSidesData,
  } = usePayment('/reporting/summary', {
    params: {
      query: {
        ...query,
        limit: 10000,
        offset: 0,
        ...(useYearlyPeriod ? { period: 'YEARLY' } : undefined),
        groupBy: ['TRANSACTION_SIDE'],
      },
    },
  });

  const buySides = useMemo(
    () =>
      transactionSidesData?.results?.find(({ side }) => side === 'BUYER')
        ?.sides ?? 0,
    [transactionSidesData],
  );
  const sellSides = useMemo(
    () =>
      transactionSidesData?.results?.find(({ side }) => side === 'SELLER')
        ?.sides ?? 0,
    [transactionSidesData],
  );

  return {
    data: data?.results ? data.results[0] : undefined,
    isLoading: isLoading || isLoadingTransactionSidesData,
    transactionSidesData: { buySides, sellSides },
  };
};
